<template>
  <div class="directorWrap">
    <el-dialog class="dialogWrap" title="" :visible.sync="visible" width="440px" :close-on-click-modal="false" append-to-body>
      <el-form ref="fundForm" :model="fundForm" :rules="fundRules" label-position="top" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="pb30">
        <el-form-item :label="$t('enroll.questionnaire.proposedFundName')" prop="fundName" ref="fundName">
          <el-input v-model="fundForm.fundName" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
        <el-form-item :label="$t('enroll.questionnaire.fundType')" prop="fundType" ref="fundType">
          <el-select v-model="fundForm.fundType" :placeholder="$t('common.placeholder.select')" class="wdb100">
            <el-option v-for="item in globalFormatList('fundTypeList')" :key="`fundType-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('enroll.questionnaire.registrationCountry')" prop="fundRegistrationCountry" ref="fundRegistrationCountry">
          <el-select v-model="fundForm.fundRegistrationCountry" :placeholder="$t('common.placeholder.select')" filterable class="wdb100">
            <el-option v-for="item in globalFormatList('countryList')" :key="`country-${item.value}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('enroll.questionnaire.registrationAddress')" prop="fundRegistration" ref="fundRegistration">
          <el-input v-model="fundForm.fundRegistration" :placeholder="$t('common.placeholder.enter')" class="wdb100"></el-input>
        </el-form-item>
        <div class="pt20 wdb100 fxRow" v-if="!isReadonly">
          <el-button type="primary" @click="onSubmit" class="pl20 pr20">{{ $t("common.button.affirm") }}</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FundInfoAddOrUpdate",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      fundForm: {
        fundName: null,
        fundType: null,
        fundRegistrationCountry: null,
        fundRegistration: null,
      },
      getIdx: null,
      fundRules: {
        fundName: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
        fundType: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        fundRegistrationCountry: [{ required: true, message: this.$t("common.placeholder.select"), trigger: "submit" }],
        fundRegistration: [{ required: true, message: this.$t("common.placeholder.enter"), trigger: "submit" }],
      },
    };
  },
  computed: {
    ...mapGetters("constant", ["globalFormatList"]),
  },
  methods: {
    init(index, row) {
      this.getIdx = index;
      if (index === "add") {
        this.fundForm = { fundName: null, fundType: null, fundRegistrationCountry: null, fundRegistration: null };
      } else {
        this.fundForm = JSON.parse(JSON.stringify(row));
      }
      if (this.$refs["fundForm"]) this.$refs["fundForm"].clearValidate();
      this.visible = true;
    },
    onSubmit() {
      this.$refs["fundForm"].validate(valid => {
        if (valid) {
          this.$emit("update", this.fundForm, this.getIdx);
          this.visible = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dialogWrap ::v-deep {
  .el-form-item__label {
    padding: 0;
  }
  .el-form-item {
    margin-bottom: 20px;
  }
}
</style>
